import React from 'react';
import { TextField, IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

export default function EndpointArgs({ endpoint, fetchDataForEndpoint, setEndpointArgs }) {
  return (
    <>
      {endpoint.optional_args.map(
        (arg, argIndex) => arg.key && (
          <TextField
            placeholder={arg.label}
            label={arg.label}
            size="small"
            variant="outlined"
            sx={{ mr: 1, mb: 1 }}
            defaultValue={arg.value}
            margin="dense"
            name={arg.key}
            key={crypto.randomUUID()}
            onBlur={(e) => {
              const newArgs = [...endpoint.optional_args];
              newArgs[argIndex].value = e.target.value;
              setEndpointArgs(endpoint, newArgs);
            }}
          />
        ),
      )}
      <IconButton
        onClick={() => fetchDataForEndpoint(endpoint.path)}
        size="small"
        aria-label="Refresh"
      >
        <RefreshIcon />
      </IconButton>
    </>
  );
}
